import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FileResponse} from '../../../../models/file.response';
import {saveAs} from 'file-saver';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {CoreService, DocumentService} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-order-element-changed',
  templateUrl: 'changed.overlay.component.html'
})
export class ChangedOverlayComponent implements OnInit {

  docName: string;
  docId: number;

  constructor(@Inject(MAT_DIALOG_DATA) public change: any, private documentsService: DocumentService, private coreService: CoreService,
              private dialogRef: MatDialogRef<any>, @Inject(APP_GUIDS) private guids: AppGuids) {
  }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close();
  }

  accept() {
    this.coreService.executeAction(this.change.posId, '§' + this.guids.GUID_ACTION_ACCEPT_CHANGE, null).subscribe(result => {
      this.dialogRef.close(true);
    }, error => this.dialogRef.close(false));
  }

  downloadDocument(docId: string) {
    return this.documentsService.getDocumentFile(docId).subscribe(response => {
        const fileResponse: FileResponse = FileResponse.parseResponse(response);
        saveAs(fileResponse.content, fileResponse.fileName);
      }
    );
  }

}
